import { z } from 'zod';

export const AreaMaterialSchema = z.object({
  id: z.string().uuid(),
  area_id: z.string().uuid(),
  spec_code: z.string(),
  material_id: z.string().uuid(),
  notes: z.string().nullable(),
});

export const CreateAreaMaterialSchema = z.object({
  area_id: z.string().uuid(),
  spec_code: z.string().min(1, 'Spec code is required'),
  material_id: z.string().uuid(),
  notes: z.string().nullable().optional(),
});

export const UpdateAreaMaterialSchema = CreateAreaMaterialSchema.partial();

export type AreaMaterial = z.infer<typeof AreaMaterialSchema>;
export type CreateAreaMaterial = z.infer<typeof CreateAreaMaterialSchema>;
export type UpdateAreaMaterial = z.infer<typeof UpdateAreaMaterialSchema>;
